module.exports = __webpack_public_path__ + "img/parents_choose.e7779b0c.png";